<template>
    <div class="border-right pr-2 mr-2">
        <span>
            <small>Último Acesso</small>
        </span>
        <br />
        <strong>
            <span>
                {{$store.getters.usuario.ultimoAcesso && $store.getters.usuario.ultimoAcesso !== ''
                ? $moment($store.getters.usuario.ultimoAcesso).format(
                'DD/MM/YYYY HH:mm'
                )
                : ''}}
            </span>
        </strong>
    </div>
</template>

<script >
export default {
	name: 'UltimoAcesso',

	data() {
		return {}
	},

	methods: {},

	created() {}
}
</script>
